export default __webpack_public_path__ + "static/media/soesvinget-property-14.6cef1283.jpg";